// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_AbertoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for caixaAberto() — GET /caixa/aberto
 *
 * Retorna se existe caixa aberto para a franquia e os dados do caixa.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_AbertoResponseDados {
tem_caixa_aberto?: boolean
id?: number
franquia_id?: number
operador_id?: number
operador_nome?: string
data_hora_abertura?: string
saldo_inicial?: number
saldo_atual?: number
status?: string
observacao?: string
created_at?: string
}

export type Caixa_AbertoResponse = ApiResponse<Caixa_AbertoResponseDados>;

registerResponseContract('Caixa_AbertoResponse', {
  tem_caixa_aberto:   { type: 'boolean', required: false },
  id:                 { type: 'number',  required: false },
  franquia_id:        { type: 'number',  required: false },
  operador_id:        { type: 'number',  required: false },
  operador_nome:      { type: 'string',  required: false },
  data_hora_abertura: { type: 'string',  required: false },
  saldo_inicial:      { type: 'number',  required: false },
  saldo_atual:        { type: 'number',  required: false },
  status:             { type: 'string',  required: false },
  observacao:         { type: 'string',  required: false },
  created_at:         { type: 'string',  required: false },
})
